import React, { Component } from 'react';
import { motion } from 'framer-motion';
import StarStory from '../components/StarStory';
import AnimatedCounter from '../components/AnimatedCounter';
const ScoutForcePage = () => {
  return <div className="bg-white min-h-screen" data-id="element-475">
      <div className="container mx-auto px-4 py-16" data-id="element-476">
        {/* Header Section */}
        <div className="flex flex-col md:flex-row items-center md:items-start gap-6 mb-12" data-id="element-477">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/rGvLnwozxZsFyj5GqYcwtn/1631323871027.jpg" alt="ScoutForce logo" className="w-24 h-24 object-contain" data-id="element-478" />
          <div data-id="element-479">
            <motion.h1 className="text-4xl font-bold text-gray-800 mb-2" initial={{
            opacity: 0.5
          }} animate={{
            opacity: 1
          }} transition={{
            duration: 0.5
          }} data-id="element-480">
              Product Manager at ScoutForce
            </motion.h1>
            <motion.p className="text-xl text-gray-700 mb-4" initial={{
            opacity: 0.5
          }} animate={{
            opacity: 1
          }} transition={{
            duration: 0.5,
            delay: 0.2
          }} data-id="element-481">
              2008 — 2011
            </motion.p>
            <motion.div className="bg-gray-100 p-4 rounded-lg" initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} transition={{
            duration: 0.5,
            delay: 0.4
          }} data-id="element-482">
              <p className="text-gray-700" data-id="element-483">
                <span className="font-bold" data-id="element-484">Context:</span> Early-stage sports
                recruiting platform. Transformed college athletic recruiting.
              </p>
            </motion.div>
          </div>
        </div>
        {/* STAR Stories */}
        <StarStory title="Division I Recruiting Platform" situation="College athletic recruiting was inefficient and paper-based. Coaches spent excessive time traveling to evaluate prospects, and athletes lacked visibility into opportunities." task="Build a digital platform to connect college coaches with high school athletes and streamline the recruiting process." action="I led the development of a searchable athlete database with verified stats, game footage, and academic records. We created coach-specific workflows that matched recruiting needs with athlete profiles. I also designed a messaging system compliant with NCAA regulations and built analytics dashboards for tracking recruiting pipelines." result="ScoutForce captured 40% of Division I recruiting programs across all major sports. The platform facilitated over 12,000 athletic scholarships in three years, with an estimated $280M in scholarship value." imageUrl="https://via.placeholder.com/600x400?text=ScoutForce+Dashboard" imageAlt="ScoutForce coach dashboard interface" animationComponent={<div className="bg-white p-6 rounded-lg shadow-md" data-id="element-486">
              <h4 className="text-lg font-bold mb-4 text-center" data-id="element-487">
                Platform Impact
              </h4>
              <div className="flex justify-between items-center mb-2" data-id="element-488">
                <span className="text-gray-700" data-id="element-489">D1 Market Share:</span>
                <AnimatedCounter start={0} end={40} suffix="%" data-id="element-490" />
              </div>
              <div className="flex justify-between items-center" data-id="element-491">
                <span className="text-gray-700" data-id="element-492">Scholarships Facilitated:</span>
                <AnimatedCounter start={0} end={12000} suffix="+" data-id="element-493" />
              </div>
            </div>} data-id="element-485" />
        <StarStory title="Video Analysis Tools" situation="Coaches were struggling to efficiently evaluate large volumes of athlete footage. The existing process was manual and time-consuming." task="Create video analysis tools that would allow coaches to quickly assess athletic talent and make recruiting decisions." action="I designed an innovative video clipping and annotation system. Coaches could tag key moments, compare athletes side-by-side, and create shareable highlight reels. We implemented automated tracking for sport-specific metrics (sprint speed, vertical jump, etc.) and built collaborative evaluation tools for coaching staffs." result="Reduced video evaluation time by 63%. Coaches reported making 3x more recruiting decisions in the same time period. The video tools became our most cited reason for platform adoption." imageUrl="https://via.placeholder.com/600x400?text=Video+Analysis+Tool" imageAlt="Video analysis interface with annotation tools" animationComponent={<div className="bg-white p-6 rounded-lg shadow-md" data-id="element-495">
              <h4 className="text-lg font-bold mb-4 text-center" data-id="element-496">
                Efficiency Gains
              </h4>
              <div className="flex justify-between items-center mb-2" data-id="element-497">
                <span className="text-gray-700" data-id="element-498">Evaluation Time:</span>
                <div className="flex items-center" data-id="element-499">
                  <span className="text-gray-700 mr-1" data-id="element-500">-</span>
                  <AnimatedCounter start={0} end={63} suffix="%" data-id="element-501" />
                </div>
              </div>
              <div className="flex justify-between items-center" data-id="element-502">
                <span className="text-gray-700" data-id="element-503">Decision Throughput:</span>
                <AnimatedCounter start={1} end={3} suffix="x" data-id="element-504" />
              </div>
            </div>} data-id="element-494" />
        <StarStory title="Mobile Scouting App" situation="Coaches needed to scout and record evaluations at games and tournaments, but our platform was desktop-only." task="Extend ScoutForce to mobile devices for real-time scouting and evaluation." action="I led the development of iOS and Android apps focused on the core scouting workflow. We built offline functionality for venues with poor connectivity and integrated the camera for on-the-spot video capture. I also designed a simplified evaluation form that coaches could complete in under 60 seconds between plays." result="Mobile adoption reached 76% of our user base within 6 months. In-person evaluations increased by 42%, and coaches reported discovering 28% more prospects through impromptu scouting." imageUrl="https://via.placeholder.com/600x400?text=Mobile+Scouting+App" imageAlt="Mobile scouting app on smartphone" animationComponent={<div className="bg-white p-6 rounded-lg shadow-md" data-id="element-506">
              <h4 className="text-lg font-bold mb-4 text-center" data-id="element-507">
                Mobile Impact
              </h4>
              <div className="flex justify-between items-center mb-2" data-id="element-508">
                <span className="text-gray-700" data-id="element-509">Mobile Adoption:</span>
                <AnimatedCounter start={0} end={76} suffix="%" data-id="element-510" />
              </div>
              <div className="flex justify-between items-center" data-id="element-511">
                <span className="text-gray-700" data-id="element-512">Evaluation Increase:</span>
                <div className="flex items-center" data-id="element-513">
                  <span className="text-gray-700 mr-1" data-id="element-514">+</span>
                  <AnimatedCounter start={0} end={42} suffix="%" data-id="element-515" />
                </div>
              </div>
            </div>} data-id="element-505" />
        {/* Testimonial */}
        <motion.div className="mt-16 bg-gray-100 p-8 rounded-lg" initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} data-id="element-516">
          <p className="text-xl text-gray-700 italic mb-4" data-id="element-517">
            "As one of our first PMs, Aakash helped us capture 40% of Division I
            recruiting programs."
          </p>
          <p className="text-gray-800 font-bold" data-id="element-518">— Steve Iacco, CEO</p>
        </motion.div>
      </div>
    </div>;
};
export default ScoutForcePage;